import { ReactNode } from 'react';
import { useWindowSize } from '../../../../hooks/UseWindowSize';
import { donedealBreakpoints } from 'styled-system';

const ResponsiveDisplay = (props: {
  small: boolean;
  medium: boolean;
  large: boolean;
  children: ReactNode;
}) => {
  const { small, medium, large, children } = props;

  const screenSize = useScreenSize();

  if (screenSize === 'small' && small) {
    return <>{children}</>;
  }
  if (screenSize === 'medium' && medium) {
    return <>{children}</>;
  }
  if (screenSize === 'large' && large) {
    return <>{children}</>;
  }
  return null;
};

function useScreenSize() {
  const { width } = useWindowSize();

  if (width && width < donedealBreakpoints.SCREEN_MEDIUM) {
    return 'small';
  }
  if (width && width < donedealBreakpoints.SCREEN_LARGE) {
    return 'medium';
  }
  return 'large';
}

export default ResponsiveDisplay;
